module.exports = __webpack_public_path__ + "img/btn-17-system.4c418c95.png";